import React from 'react';

import Button from 'CommonComponents/Button';
import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';

const ConfirmationModal = ({ cancelButtonFirst = true, submitButtonVariant = 'danger', cancelButtonVariant = 'secondary', ...props }) => {
    const submitRequest = () => {
        props.triggerAction && typeof props.triggerAction === 'function' && props.triggerAction();
    };

    const internalCloseHandler = () => {
        props.cleanStates && typeof props.cleanStates === 'function' && props.cleanStates();
        props.closeHandler && typeof props.closeHandler === 'function' && props.closeHandler();
    };

    const internalSuccessHandler = () => {
        props.cleanStates && typeof props.cleanStates === 'function' && props.cleanStates();
        props.successHandler && typeof props.successHandler === 'function' && props.successHandler();
    };

    const close = () => {
        if (props.actionCompleted || props.actionFailed) {
            internalSuccessHandler();
        } else {
            internalCloseHandler();
        }
        props.modalElement.hide();
    };

    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t(props.title)} close={close}></ModalHeader>
                    <div className="tw-rounded-b">
                        {props.allowAction && (
                            <div className="modal__form-container">
                                {!props.actionCompleted && !props.actionFailed && (
                                    <>
                                        <p className="modal__msg modal__text-color">
                                            {props.confirmationMsg}
                                            {props.warningMsg && props.warningMsg != '' && (
                                                <span className="tw-text-sm tw-font-normal modal__text-color">
                                                    (<span className="tw-text-red-500">Warning</span> - {props.warningMsg})
                                                </span>
                                            )}
                                        </p>
                                        {props.children}
                                        <ModalFooter
                                            primaryButtonDisabled={!!props.primaryButtonDisabled}
                                            cancelButtonText={$t(props.cancelButtonText)}
                                            primaryButtonText={$t(props.primaryButtonText)}
                                            cancelButtonFirst={cancelButtonFirst}
                                            cancelButtonVariant={cancelButtonVariant}
                                            submitButtonVariant={submitButtonVariant}
                                            onCancel={close}
                                            handleSubmit={submitRequest}
                                            isSubmitting={props.request}
                                        ></ModalFooter>
                                    </>
                                )}
                                {props.actionCompleted && (
                                    <div className="tw-grid tw-grid-cols-1">
                                        <p className="modal__msg modal__text-color">{props.actionCompletedMsg}</p>
                                    </div>
                                )}
                                {props.actionFailed && (
                                    <div className="tw-grid tw-grid-cols-1">
                                        <p className="modal__msg modal__error-text-color">{props.actionFailedMsg}</p>
                                    </div>
                                )}
                                {(props.actionCompleted || props.actionFailed) && (
                                    <div className="modal__footer">
                                        <Button variant={cancelButtonVariant} onClick={internalSuccessHandler}>
                                            {$t('Close')}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ConfirmationModal);
